<div class="tax-setting-container" [formGroup]="taxSettingsForm">
    <div class="row mb-3">
        <label>
            {{ 'PROPERTIES_TAX_SETTINGS_DESCRIPTION' | translate }}
        </label>
    </div>
    <div class="row row-height col-sm-8 font-weight-bold">
        <div class="col-sm-6"><label>{{ 'PROPERTIES_TAX_SETTINGS_ESTIMATED_USE_TAX' | translate }}</label></div>
        <div class="col-sm-6"><label>{{ 'PROPERTIES_TAX_SETTINGS_ESTIMATED_SALES_TAX' | translate }}</label></div>
    </div>
    <div class="row row-height col-sm-8">
        <div class="col-sm-6">
            <mat-checkbox color="primary" formControlName="useTaxLabor">{{ 'PROPERTIES_TAX_SETTINGS_LABOR' | translate }}</mat-checkbox>
        </div>
        <div class="col-sm-6">
            <mat-checkbox color="primary" formControlName="salesTaxLabor" >{{ 'PROPERTIES_TAX_SETTINGS_LABOR' | translate }}</mat-checkbox>
        </div>
    </div>
    <div class="row row-height col-sm-8">
        <div class="col-sm-6">
            <mat-checkbox color="primary" formControlName="useTaxMaterial" >{{ 'PROPERTIES_TAX_SETTINGS_MATERIAL' | translate }}</mat-checkbox>
        </div>
        <div class="col-sm-6">
            <mat-checkbox color="primary" formControlName="salesTaxMaterial" >{{ 'PROPERTIES_TAX_SETTINGS_MATERIAL' | translate }}</mat-checkbox>
        </div>
    </div>
    <div class="row row-height col-sm-8">
        <div class="col-sm-6">
            <mat-checkbox color="primary" formControlName="useTaxShipping" >{{ 'PROPERTIES_TAX_SETTINGS_SHIPPING_HANDLING' | translate }}</mat-checkbox>
        </div>
        <div class="col-sm-6">
            <mat-checkbox color="primary" formControlName="salesTaxShipping" >{{ 'PROPERTIES_TAX_SETTINGS_SHIPPING_HANDLING' | translate }}</mat-checkbox>
        </div>
    </div>
    <div class="row row-height col-sm-8">
        <div class="col-sm-6">
            <mat-checkbox color="primary" formControlName="useTaxWarranty" >{{ 'PROPERTIES_TAX_SETTINGS_WARRANTY' | translate }}</mat-checkbox>
        </div>
        <div class="col-sm-6">
            <mat-checkbox color="primary" formControlName="salesTaxWarranty" >{{ 'PROPERTIES_TAX_SETTINGS_WARRANTY' | translate }}</mat-checkbox>
        </div>
    </div>
    <div class="row row-height col-sm-8">
        <div class="col-sm-6">
            <mat-checkbox color="primary" formControlName="useTaxSubcontractors">{{ 'PROPERTIES_TAX_SETTINGS_SUBCONTRACTORS' | translate }}</mat-checkbox>
        </div>
        <div class="col-sm-6">
            <mat-checkbox color="primary" formControlName="salesTaxSubcontractors" >{{ 'PROPERTIES_TAX_SETTINGS_SUBCONTRACTORS' | translate }}</mat-checkbox>
        </div>
    </div>
    <div class="row row-height col-sm-8">
        <div class="col-sm-6">
            <mat-checkbox color="primary" formControlName="useTaxMiscTravel">{{ 'PROPERTIES_TAX_SETTINGS_MISC_TRAVEL' | translate }}</mat-checkbox>
        </div>
        <div class="col-sm-6 d-flex align-items-center">
            <mat-checkbox color="primary" formControlName="salesTaxMiscTravel" >{{ 'PROPERTIES_TAX_SETTINGS_MISC_TRAVEL' | translate }}</mat-checkbox>
            <mat-icon matTooltip="{{ 'TAX_SETTINGS_MISC_AND_TRAVEL_INFO' | translate }}">info</mat-icon>
        </div>
    </div>
</div>